import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  HomeworkPreview,
  MODE,
} from '@grcs/views/shared/components/Homework/HomeworkPreview';
import { AdminAddClassPageEnhanced as AdminAddClassPage } from '@grcs/views/Admin/AdminClass/AdminAddClassPage.enhanced';
import { AdminClassPageEnhanced as AdminClassPage } from '@grcs/views/Admin/AdminClass/AdminClassPage.enhanced';
import { AdminClassStudentAddPageEnhanced as AdminClassStudentAddPage } from '@grcs/views/Admin/AdminClass/AdminClassStudentAddPage.enhanced';
import { AdminClassStudentPageEnhanced as AdminClassStudentPage } from '@grcs/views/Admin/AdminClass/AdminClassStudentPage.enhanced';
import { AdminClassTeacherUpdatePageEnhanced as AdminClassTeacherUpdatePage } from '@grcs/views/Admin/AdminClass/AdminClassTeacherUpdatePage.enhanced';
import { AdminEditClassPageEnhanced as AdminEditClassPage } from '@grcs/views/Admin/AdminClass/AdminEditClassPage.enhanced';
import { AdminHomePageEnhanced as AdminHomePage } from '@grcs/views/Admin/AdminHomePage.enhanced';
import { AdminLibraryPageEnhanced as AdminLibraryPage } from '@grcs/views/Admin/AdminLibrary/AdminLibraryPage.enhanced';
import { AdminSemesterPageEnhanced as AdminSemesterPage } from '@grcs/views/Admin/AdminSemester/AdminSemesterPage.enhanced';
import { AdminStudentBulkUploadEnhanced as AdminStudentBulkUpload } from '@grcs/views/Admin/AdminStudent/AdminStudentBulkUpload.enhanced';
import { AdminStudentPageEnhanced as AdminStudentPage } from '@grcs/views/Admin/AdminStudent/AdminStudentPage.enhanced';
import { AdminTeacherPageEnhanced as AdminTeacherPage } from '@grcs/views/Admin/AdminTeacher/AdminTeacherPage.enhanced';
import { AdminUpdatePasswordPageEnhanced as AdminUpdatePasswordPage } from '@grcs/views/Admin/AdminUser/AdminUpdatePasswordPage.enhanced';
import { AdminUserAddPageEnhanced as AdminUserAddPage } from '@grcs/views/Admin/AdminUser/AdminUserAddPage.enhanced';
import { AdminUserEditPageEnhanced as AdminUserEditPage } from '@grcs/views/Admin/AdminUser/AdminUserEditPage.enhanced';
import { AdminCreatePageEnhanced as AdminCreatePage } from '@grcs/views/Admin/AdminCreatePage.enhanced';
import { AdminLogPageEnhanced as AdminLogPage } from '@grcs/views/Admin/AdminLogPage.enhanced';
import { AdminAITestPageEnhanced as AdminAITestPage } from '@grcs/views/Admin/AdminAITestPage.enhanced';
import { AnalyticsPageEnhanced as AnalyticsPage } from '@grcs/views/Analytics/AnalyticsPage.enhanced';
import { ClassDashboardEnhanced as ClassDashboard } from '@grcs/views/Class/ClassDashboard.enhanced';
import { HomeworkCreateEnhanced as HomeworkCreate } from '@grcs/views/Homework/HomeworkCreate.enhanced';
import { HomeworkEditEnhanced as HomeworkEdit } from '@grcs/views/Homework/HomeworkEdit.enhanced';
import { LeaderboardPageEnhanced as LeaderboardPage } from '@grcs/views/Leaderboard/LeaderboardPage.enhanced';
import { ReportEnhanced as Report } from '@grcs/views/Report.enhanced';
import { ToolsPageEnhanced as ToolsPage } from '@grcs/views/Tools/ToolsPage.enhanced';
import { VocabularyEnhanced as Vocabulary } from '@grcs/views/Vocabulary.enhanced';

export const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminHomePage />} />
      <Route path="semesters" element={<AdminSemesterPage />} />
      <Route
        path=":year/class/:classId"
        element={<ClassDashboard from="home" />}
      />
      <Route
        path=":year/class/:classId/students"
        element={<AdminClassStudentPage />}
      />

      <Route
        path=":year/class/:classId/teacher/update"
        element={<AdminClassTeacherUpdatePage />}
      />
      <Route
        path=":year/class/:classId/students/new"
        element={<AdminClassStudentAddPage />}
      />
      <Route path="class" element={<AdminClassPage />} />
      <Route path=":year/class" element={<AdminClassPage />} />
      <Route path="class/new" element={<AdminAddClassPage />} />
      <Route path="class/:classId/edit" element={<AdminEditClassPage />} />
      <Route path="teacher" element={<AdminTeacherPage />} />
      <Route path="student" element={<AdminStudentPage />} />
      <Route path="student/bulk" element={<AdminStudentBulkUpload />} />
      <Route path="user/:userId" element={<AdminUserEditPage />} />
      <Route path="user/new/:roleType" element={<AdminUserAddPage />} />
      <Route path="library" element={<AdminLibraryPage />} />
      <Route path="library/new" element={<HomeworkCreate />} />
      <Route
        path="library/:contentId/view"
        element={<HomeworkPreview mode={MODE.PREVIEW} />}
      />
      <Route path="library/:contentId/edit" element={<HomeworkEdit />} />
      <Route path="report" element={<Report />} />
      <Route path="vocabulary" element={<Vocabulary />} />
      <Route path="update-password" element={<AdminUpdatePasswordPage />} />
      <Route path="analytics" element={<AnalyticsPage />} />
      <Route path="leaderboard" element={<LeaderboardPage />} />
      <Route path="tools" element={<ToolsPage />} />
      <Route path="create" element={<AdminCreatePage />} />
      <Route path="log" element={<AdminLogPage />} />
      <Route path="ai-test" element={<AdminAITestPage />} />
    </Routes>
  );
};
